import {
    FETCH_TnC_SUCCESS_ACTION,
  } from "./action";
  
  const initialState = {
    processing: false,
    error: false
  };
  
  export default function(state: any = initialState, action: Function) {
    switch (action.type) {
      case FETCH_TnC_SUCCESS_ACTION:
        return {
          ...state,
          tnc:action.payload.rows,
        }
      default:
        return {
          ...state
        };
    }
  }
  